import { ApiMask, updateApiMask } from '../../../logger/BitMask';
import { Fetcher } from '../../Fetcher';

import { StatsSettingsType } from './types';

export interface FetchStatsSettingsParams {
  url: string;
}

export const fetchStatsSettings = ({ url }: FetchStatsSettingsParams): Promise<StatsSettingsType> => {
  return Fetcher.fetch<StatsSettingsType>(url + '/eventcapture/settings').then<StatsSettingsType>((result) => {
    updateApiMask(ApiMask.StatsSettings);
    return result;
  });
};
